<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest} fill="none">
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M4.35146 10.5596C9.72016 8.22051 13.3001 6.67846 15.0914 5.93342C20.2058 3.80617 21.2685 3.43665 21.9611 3.42445C22.1135 3.42176 22.4541 3.45952 22.6748 3.63856C22.8611 3.78974 22.9123 3.99396 22.9369 4.13729C22.9614 4.28063 22.992 4.60715 22.9677 4.86228C22.6905 7.77432 21.4913 14.8411 20.8812 18.1026C20.623 19.4827 20.1147 19.9454 19.6226 19.9907C18.5532 20.0891 17.7411 19.2839 16.7052 18.6049C15.0844 17.5424 14.1687 16.881 12.5953 15.8442C10.7771 14.646 11.9558 13.9874 12.992 12.9112C13.2632 12.6295 17.9753 8.34352 18.0665 7.95472C18.0779 7.90609 18.0885 7.72483 17.9808 7.62912C17.8731 7.53341 17.7142 7.56614 17.5995 7.59217C17.4369 7.62907 14.8476 9.34053 9.83143 12.7266C9.09645 13.2313 8.43073 13.4772 7.83426 13.4643C7.17671 13.4501 5.91184 13.0925 4.97154 12.7868C3.81822 12.4119 2.90159 12.2137 2.98141 11.577C3.02298 11.2454 3.47967 10.9063 4.35146 10.5596Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
